import React from 'react';
import { useSpring, animated } from '@react-spring/web';

export const AnimatedPath = ({ path, color, opacity, blur }) => {
  const springProps = useSpring({
    to: {
      d: path,
      fill: color,
      stroke: color,
    },
    config: {
      mass: 10,
      tension: 20,
      friction: 60,
      duration: 3000, 
    },
  });

  return (
    <animated.path
      d={springProps.d}
      fill={springProps.fill}
      fillOpacity={opacity}
      stroke={springProps.stroke}
      strokeOpacity={0.8}
      strokeWidth={2}
      style={{ filter: `blur(${blur}px)` }}
    />
  );
};
